<template>
	<div>
		<breadcrumb :routerList="[{to:'/processLayout',title:'流程配置'},{title:'查看详情'}]"/>
		<div class="h-content">
			<div class="h-row h-mrt0">
				<div class="h-rowIn">
					<div class="h-rowBox">
						<div class="h-rowCon">
							<div class="h-pieceIn2">
								<div class="h-pieceTitle2" style="margin-bottom:0.2rem">
									<h1 style="border:none">流程基础信息</h1>
								</div>
								<div class="h-pieceCon2" style="width:100%;padding:10px;background:#fcfcfc;border-radius:10px;border:1px solid #ccc">
									<el-form :model="formLabelAlign" label-position="right" ref="formLabelAlign" :inline="true"  class="demo-ruleForm h-formbLine">
                                        <el-form-item label="流程名称" class="h-elformWrap-1" prop="formCon1">
                                            <el-input v-model="formLabelAlign.formCon1" placeholder="齐鲁医院XXXX设备折扣审批"></el-input>
                                        </el-form-item>
                                        <el-form-item label="流程简介" class="h-elformWrap-1" prop="formCon2">
                                            <el-input v-model="formLabelAlign.formCon2" maxlength="70" placeholder="齐鲁医院XXXX设备折扣审批"></el-input>
                                            <el-input style="margin: 20px 0;" maxlength="70" v-model="formLabelAlign.formCon2" placeholder="齐鲁医院XXXX设备折扣审批"></el-input>
                                            <el-input v-model="formLabelAlign.formCon2" maxlength="70" placeholder="齐鲁医院XXXX设备折扣审批"></el-input>
                                        </el-form-item>
                                    </el-form>
								</div>
							</div>
							<div class="h-pieceIn2">
								<div class="h-pieceTitle2" style="margin-bottom:0.2rem">
									<h1 style="border:none">流程配置</h1>
                                    <span style="color: #868686;font-size:0.18rem;margin-left:0.1rem">可将流程节点拖拽至流程配置中</span>
								</div>
								<div class="h-pieceCon2" style="width:100%;padding:10px;background:#fcfcfc;border-radius:10px;border:1px solid #ccc">
									
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data(){
      return{
            formLabelAlign:{
                formCon1:'',
                formCon2:'',
            }
        }
    },
    methods:{
        
    }
}
</script>

<style scoped>

</style>
